import $http from "../../../../axios-instance";

/**
 * Cargar las categorías de SGA.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} state - Estado de las categorías de SGA.
 * @param reloadPage - Recargar la página.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function getCategoriesSga({ commit, state }, reloadPage = false) {
    commit("dashboard/load", true, { root: true });
    try {
        const { page, per_page, name, is_active } = state.filterCategoriesSga;

        const response = await $http.get("sga/category-list", {
            params: {
                page: reloadPage ? 1 : page,
                perPages: per_page,
                search: name,
                is_active,
            },
        });
        commit("setCategoriesSga", response.data.data);
        commit("setPaginateCategoriesSga", response.data.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Crear una nueva categoría de SGA.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} category - Categoria de SGA.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function createCategorySga({ commit }, category) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.post("sga/category-create", category);
        this.$vue.$alertSuccess(response.data.message);
        return true;
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return false;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Cambiar el estado de la categoría de SGA.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} id - Identificador de la categoría de SGA.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function changeStatusCategorySga({ commit }, id) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.put(`sga/category-change-status/${id}`);
        this.$vue.$alertSuccess(response.data.message);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Actualizar la categoría de SGA.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} category - Categoría de SGA.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function updateCategorySga({ commit }, category) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.put(
            `sga/category-update/${category.id}`,
            category
        );
        this.$vue.$alertSuccess(response.data.message);
        return true;
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return false;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Cargar la categoría de SGA segun su id.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} id - Identificador de la categoría de SGA.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function showCategorySga({ commit }, id) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.get(`sga/category-show/${id}`);
        commit("setCategorieSga", response.data.data);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Cargar las categorías activas de SGA.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function getActiveCategoriesSga({ commit }) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.get("sga/category-list-actives");
        commit("setActiveCategoriesSga", response.data.data);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Sincronizar los lenguajes de las categorías de SGA.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function asyncLanguagesCategoriesSga({ commit }) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http.post("sga/category-translate-all");
        this.$vue.$alertSuccess(response.data.message);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}
